module.exports = __webpack_public_path__ + "img/logo.b19f33ed.svg";